import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const Rendervsaform = () => {

const navigate = useNavigate();
	

/*
had an error with sessionStorage.getItem("RESTURL") returning null 
when below declaration was before this const Rendervsaform
*/
const resturl=sessionStorage.getItem("RESTURL");
//var boolFetchingSads=false;


//getresturl();



window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const navVsaform = React.useRef();
const navWpvouchers = React.useRef();
const navVsastatus = React.useRef();

const [vsaapp, setVsaapp] = useState({VSA_APP_ID:''});
const [tblvsaapps, setTblvsaapps] = useState({
loaded:false
,newrows:[]
,unpdrows:[]
,pdrows:[]
,rfsdrows:[]
});
const [linkvsaform, setLinkvsaform] = useState({VSA_APP_ID:0});
const [linkvouchers, setLinkvouchers] = useState({VSA_APP_ID:0});
const [linkvsastatus, setLinkvsastatus] = useState({VSA_APP_ID:0});

const [searchcrit, setSearchcrit] = useState({txt:''});
const startupMins=5;//here on test page this will be 10 seconds
const [reload, setReload] = useState({mins:startupMins});



const location = useLocation();
let reloadTimer=null;
//var currmins=10;
const timerEvent = () => {
	
	const currmins=1*(document.getElementsByName("inputminsremain")[0].value)-1;
	if (currmins>=0)
		setReload({mins:currmins});
	else{
		
		setReload({mins:startupMins});
	}
		

/*
	setReload((prev)=>{
		
		console.log("currmins: "+currmins); 
		return {...prev, mins:currmins}
		});

*/

	};

useEffect(() => {
//console.log('useEffect resturl: '+sessionStorage.getItem("RESTURL"));

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if


document.title =   "APS Applications";	
//return () => clearInterval(reloadTimer);
if (tblvsaapps.loaded==false){
	gettblvsaapps();
	}//end if
	
	
 },[]);



useEffect(() => {

if (reload.mins==startupMins)
	gettblvsaapps();

	if (document.getElementById('newapps')){
		const evt={
		currentTarget:document.getElementById('newapps')
		};
		//console.log("evt.currentTarget.className: "+evt.currentTarget.className);
		openCity(evt, "newappstc");
		}//end if
	document.getElementsByName('searchcrit')[0].focus();
	
 },[reload.mins]);

useEffect(() => {


	console.log("reloadTimer: "+reloadTimer);
	if (reloadTimer==null)
		reloadTimer = setInterval(timerEvent, 1000*60);//*60
	else{

		}//end else

    // Stops the old timer when umount the component.
    return function stopTimer() {
      clearInterval(reloadTimer);
    }
		

 },[JSON.stringify(tblvsaapps)]);



 useEffect(() => {
	if (linkvsaform.VSA_APP_ID>0)
		navVsaform.current?.click();
 },[linkvsaform]);


 useEffect(() => {
	if (linkvsastatus.VSA_APP_ID>0)
		navVsastatus.current?.click();
 },[linkvsastatus]);


useEffect(() => {
	if (linkvouchers.VSA_APP_ID>0)
		navWpvouchers.current?.click();
 },[linkvouchers]);

useEffect(() => {
		gettblvsaapps();
 },[searchcrit]);

function searchcritChange(e){
	setSearchcrit({txt:e.target.value});
}//end if


function getresturl(){
console.log('getresturl( location.state: '+JSON.stringify(location.state))	;
for(var attributename in location.state){
	if (attributename=='resturl')
		return location.state.resturl;
	}//end for	
return null;	
}//end func

function setCaseWorker(e){
	e.preventDefault();
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), VSA_APP_ID:vsaapp.VSA_APP_ID} )
  };		

  fetch(resturl+'rarvsaform/setcaseworker',requestOptions)
      .then(res => res.json())
      .then(res => 	afterSetCaseWorker(res) )	
	
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function afterSetCaseWorker(res){
if (res.length==undefined)
	showsnackbar("something went wrong.  please try again");
else{	
	showsnackbar("assigning case worker is complete");
	toggleModalsm();
	}
}//end func

function gettblvsaapps(){
//const resturl=sessionStorage.getItem("RESTURL");
//console.log('resturl: '+resturl);
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), crit:searchcrit.txt.trim()} )
  };		

  fetch(resturl+'rarvsaform/gettblvsaapps',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblvsaapps(res) )
      .catch(err => console.log(err));

}//end func


function viewvsaform(e, VSA_APP_ID){
console.log('viewvsaform VSA_APP_ID: '+VSA_APP_ID);
e.preventDefault();
setLinkvsaform({VSA_APP_ID:VSA_APP_ID});
	{/*
	setLinkvsaform();
if (navVsaform.current)
	navVsaform.state={VSA_APP_ID:VSA_APP_ID};
navVsaform.current?.click();

	*/}

}//end func


function aftergettblvsaapps(res){
if (res.length==undefined)
	return;

	
console.log('aftergettblvsaapps, res.length: '+res.length);

let newrows=[], unpdrows=[], pdrows=[], rfsdrows=[];
res.map((col, index) => {
	const appid=col['VSA_APP_ID'];
	const refnum=col['REF_NUM'];
	const STATUS=col['STATUS_CODE'];
	const CORPORATE=col['CORPORATE'];
	const CASE_WORKER=col['CASE_WORKER'];
	const submitted=col['SUBMITTED_TO_CSC'];
	const VOUCHERS_TOTAL_AMT=(col.VOUCHERS_TOTAL_AMT==null)?'':'$'+col.VOUCHERS_TOTAL_AMT;
	const trkey='tr_'+appid;
	//const rdkey='rd_'+appid;
	const refnumLink=<a href="#" className="nodecor" onClick={(e)=>{handleWpappChange(e, appid, STATUS, submitted);}} ><img src='img/folderyel.png' height='18' border='0' />&nbsp;{refnum}<span className='tooltiptext'>open this application</span></a>;
	//const voucherLink=<a href="#" className="nodecor" onClick={(e)=>{vouchersLink(e, appid);}} ><img src='img/folderyel.png' height='18' border='0' />&nbsp;{VOUCHERS_TOTAL_AMT}<span className='tooltiptext'>vouchers and payment</span></a>;
	
	//const pdflink=sessionStorage.getItem("UPLOADURL")+refnum+"/coverpage.pdf";	
	
	
	const htmrow=<tr key={trkey} >
	<td align='left' className='tooltip' >&nbsp;{refnumLink}</td>
	<td align='left' >{col['SURETY_NAME']}</td>
	<td align='left' >{col['STY_MBL_PHN']}</td>
	<td align='left' >{col['APPLICANT_NAME']}</td>
	<td align='left' >{col['VSA_TYP']}</td>
	<td align='left' >{col['STATUS']}</td>
	<td align='left' >{col['VISA_STATUS']}</td>

		{/*<td align='right' className="tooltip" >{voucherLink}&nbsp;</td>*/}
	<td align='center' >{col['MODIFY_DATE_TIME']}</td>
	<td align='center' className="tooltip" >
	<span className='tooltiptext'>view the applicaiton form fields</span>
	<a href='#' onClick={(e)=>{viewvsaform(e, appid);}} className="nodecor" >{col['SUBMITTED_TO_CSC']}</a>   
	</td>
	<td align='left'  >{col['LBR_CLR_REF']}</td>
	</tr>;
	if (STATUS=='NEW' || STATUS=='NOTSUBMIT')
		newrows.push(htmrow);
	else if (STATUS=='VCHRSNOTPAID')
		unpdrows.push(htmrow);
	else if (STATUS=='VCHRSPAID')
		pdrows.push(htmrow);
	else if (STATUS=='REFUSED')
		rfsdrows.push(htmrow);
});

setTblvsaapps({
loaded:true
,newrows:newrows	
,unpdrows:unpdrows	
,pdrows:pdrows	
,rfsdrows:rfsdrows	
});
}//end func


function vouchersLink(e, appid){
	console.log('setLinkvouchers '+appid);
	e.preventDefault();
	setLinkvouchers({VSA_APP_ID:appid});

}//end func


function handleWpappChange(e, appid, STATUS, submitted){
	e.preventDefault();
	
	//console.log('handleWpappChange IRD_LOGIN_ID: '+sessionStorage.getItem("IRD_LOGIN_ID"));
	console.log('submitted: '+submitted);
	
	//return;
	setLinkvsaform({VSA_APP_ID:appid, SUBMITTED_TO_CSC:submitted});
/*
	if (sessionStorage.getItem("IRD_LOGIN_ID")==undefined || sessionStorage.getItem("IRD_LOGIN_ID")==null || submitted==null)
		setLinkvsaform({VSA_APP_ID:appid});
	else{
		console.log('USERNAME: '+sessionStorage.getItem("USERNAME"));
		console.log('STATUS: '+STATUS);
		
		if ((STATUS=='VCHRSPAID' || STATUS=='NEW' ) && sessionStorage.getItem("USERNAME")!='' && sessionStorage.getItem("USERNAME")!=null && sessionStorage.getItem("USERNAME")!=undefined)
			setLinkvsastatus({VSA_APP_ID:appid});
		else
			setLinkvouchers({VSA_APP_ID:appid});
		}//end else

*/		

}//end func


function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".trigger"))
	document.querySelector(".trigger").addEventListener("click", toggleModalsm);

if (document.querySelector(".close-button"))
	document.querySelector(".close-button").addEventListener("click", toggleModalsm);

window.addEventListener("click", windowOnClick);
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}//end func


const theadcells=<>
	<tr>
		<th>WP portal ref #</th>
		<th>surety's name</th>
		<th>surety's phone #</th>
		<th>applicant</th>
		<th>visa type</th>
		<th>status I</th>
		<th>status II</th>
		<th>last update</th>
		<th>submitted to<br/>customer service</th>
		<th>immigration<br/>reference #</th>
	</tr>

</>;

	
  return (
    <>

<table align='center' width="75%" style={{marginTop:"10px", marginBottom:"10px"}}>
<tbody>
<tr>
<td align='center'>&nbsp;</td>
<td align='center'>search criteria:&nbsp;<input name="searchcrit" size='38' defaultValue={searchcrit.txt} autoComplete="off" onChange={(e)=>{searchcritChange(e);}} onFocus={(e)=>{e.target.select();}} placeholder='any name / ref # / visa type' /></td>
<td align='center' className='tooltip' ><input size="2" name="inputminsremain" value={reload.mins} style={{textAlign:"center"}} readOnly className="gnsbro" /><span className='tooltiptext'>minutes before reload</span></td>
</tr>
</tbody>
</table>
	
<div className="tab">
  <button className="tablinks" id='newapps'    onClick={(e)=>{openCity(e, e.target.id+"tc");}} >New Applications</button>
  <button className="tablinks" id='unpaidapps' onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Unpaid Applications</button>
  <button className="tablinks" id='paidapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Paid Applications</button>
  <button className="tablinks" id='refusedapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Processing Refused</button>
</div>

<div id="newappstc" className="tabcontent">
  <h4 align='center' >Newly Submitted Applications to be checked.  After checking, payment vouchers prepared if the applicaiton is not refused</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblvsaapps.newrows}
	</tbody>
	</table>
</div>

<div id="unpaidappstc" className="tabcontent">
  <h4 align='center' >Applications with payment vouchers prepared and not yet paid</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblvsaapps.unpdrows}
	</tbody>
	</table>
</div>

<div id="paidappstc" className="tabcontent">
  <h4 align='center' >Applications with payment vouchers that have been paid</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblvsaapps.pdrows}
	</tbody>
	</table>
</div>	

<div id="refusedappstc" className="tabcontent">
  <h4 align='center' >Processing Refused - Applications imcomplete or otherwise did not meet the criteria for processing</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblvsaapps.rfsdrows}
	</tbody>
	</table>
</div>	

	<div className="modalsm">
		<div className="modalsm-content">
			<span className="close-button">&times;</span>
			<div align='center' id='modalsmtext' >
			
			<p>you are not currently the case worker assigned to this application</p>
			<p>click the second button below if you will be the case worker assigned</p>
			<p>
			<button className="button" onClick={(e)=>{ toggleModalsm(); }} >Cancel</button>
			&nbsp;&nbsp;
			<button className="button" onClick={(e)=>{ setCaseWorker(e); }} >I will be the case worker assigned</button>
			</p>
			
			</div>
		</div>
	</div>

<div id="snackbar">&nbsp;</div>
          <NavLink
		  ref={navVsaform}
          to={"/vsaform"}
		  style={{display:"none"}}
          state={{
		  VSA_APP_ID:linkvsaform.VSA_APP_ID
		  }} 
        >
		&nbsp;click here to vsaform
        </NavLink>

		<NavLink ref={navWpvouchers} to={"/wpvouchers"} style={{display:"none"}} state={{VSA_APP_ID:linkvouchers.VSA_APP_ID}} >
		click here to vouchers
		</NavLink>
          
          <NavLink ref={navVsastatus} to={"/vsastatus"} style={{display:"none"}} state={{VSA_APP_ID:linkvsastatus.VSA_APP_ID}} >
		  click here to status
		  </NavLink>
		
		
		{/*
        <NavLink ref={navVsaform} to={"/vsaform"} style={{display:"none"}}
          state={{VSA_APP_ID:0}}  >vsaform</NavLink>
		*/}



    </>
  );
  


};


export default Rendervsaform;